import React from 'react'
import { Link } from 'gatsby'
import useWindowSize from '../utils/useWindowSize'
import { prev, next, articlePager } from '../styles/single.module.scss'

export default function Pagination({ filterArticle, currPostNum, slug }) {
  const windowWidth = useWindowSize()

  const prevNum = currPostNum === 0 ? filterArticle.length - 1 : currPostNum - 1
  const nextNum = filterArticle.length - 1 === currPostNum ? 0 : currPostNum + 1

  return (
    <nav className={articlePager}>
      <ul>
        <li className={prev}>
          <Link to={`/${slug}/${filterArticle[prevNum].node.slug}`}>{windowWidth > 768 ? filterArticle[prevNum].node.title : `previous ${slug}`}</Link>
        </li>
        <li className={next}>
          <Link to={`/${slug}/${filterArticle[nextNum].node.slug}`}>{windowWidth > 768 ? filterArticle[nextNum].node.title : `next ${slug}`}</Link>
        </li>
      </ul>
    </nav>
  )
}
